var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { MEDIUM_CLASS, EXTRA_LARGE_CLASS, useElementWidth, useClassNames, } from '../../util/screen';
import { getMainImageUrls } from '../../util/image';
import { Rating } from '../rating';
import { FilterTags } from './filter-tags';
var Container = styled.div((_a = {},
    _a["&.".concat(EXTRA_LARGE_CLASS)] = {
        position: 'relative',
    },
    _a));
var Image = styled.img((_b = {
        objectFit: 'cover',
        objectPosition: 'center center',
        width: '100%',
        height: '282px',
        borderRadius: '4px'
    },
    _b["&.".concat(MEDIUM_CLASS)] = {
        height: '432px',
    },
    _b["&.".concat(EXTRA_LARGE_CLASS)] = {
        height: '628px',
    },
    _b));
var ContentWrapper = styled.div((_c = {},
    _c["&.".concat(EXTRA_LARGE_CLASS)] = {
        position: 'absolute',
        bottom: '67px',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    _c));
var Content = styled.div((_d = {
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '20px',
        paddingBottom: '20px',
        textAlign: 'center'
    },
    _d["&.".concat(MEDIUM_CLASS)] = {
        paddingTop: '30px',
        paddingBottom: '24px',
    },
    _d["&.".concat(EXTRA_LARGE_CLASS)] = {
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.2)',
        paddingTop: '27px',
        paddingBottom: '19px',
        paddingLeft: '37px',
        paddingRight: '37px',
    },
    _d));
var Title = styled.h2((_e = {
        fontSize: '30px',
        marginTop: '10px',
        marginBottom: 0,
        fontFamily: 'var(--font-family-secondary)',
        fontWeight: 'normal',
        color: '#131415'
    },
    _e["&.".concat(EXTRA_LARGE_CLASS)] = {
        fontSize: '60px',
    },
    _e));
var TagsContainer = styled.div((_f = {
        marginTop: '17px'
    },
    _f["&.".concat(MEDIUM_CLASS)] = {
        marginTop: '24px',
    },
    _f));
export var FeaturedRecipeHero = function (_a) {
    var recipe = _a.recipe, filters = _a.filters, _b = _a.showRatings, showRatings = _b === void 0 ? true : _b;
    var _c = useElementWidth(), ref = _c.ref, width = _c.width;
    var className = useClassNames(width);
    var urls = getMainImageUrls(recipe.media, '16x9');
    return (_jsxs(Container, __assign({ ref: ref, className: className }, { children: [urls && (_jsx(Image, { className: className, alt: "Featured recipe image", src: urls.src, srcSet: urls.srcSet, sizes: "100vw" }, void 0)), _jsx(ContentWrapper, __assign({ className: className }, { children: _jsxs(Content, __assign({ className: className }, { children: [showRatings ? _jsx(Rating, { value: Number(recipe.rating) }, void 0) : null, _jsx(Title, __assign({ className: className }, { children: recipe.name }), void 0), filters && (_jsx(TagsContainer, __assign({ className: className }, { children: _jsx(FilterTags, { items: filters }, void 0) }), void 0))] }), void 0) }), void 0)] }), void 0));
};
